import "UI/Widget/Forms/Control/Text";
import "UI/Widget/Text";
import "UI/Plugin/XhrAutocomplete";
/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Text
 */
UI.Widget.Forms.Control.XhrAutocomplete = Class(UI.Widget.Forms.Control.Text,
    /** @lends UI.Widget.Forms.Control.XhrAutocomplete.prototype */
    {
        /**
         * @type {UI.Plugin.XhrAutocomplete}
         */
        autocomplete: null,

        insertElement: function() {
            var self = this;

            this.ParentCall();

            var source = this.$control.attr("source");
            var column = this.$control.attr("column");
            var columns = this.$control.attr("columns");
            var strict = !!this.$control.attr("strict");
            var strictCallback = this.$control.attr("strict-callback");
            var handler = this.$control.attr("on-select");
            var emptyHandler = this.$control.attr("on-empty");
            var sourceOptions = this.$control.data("source-options");
            var binding = this.$control.attr("bind");
            var anchor = this.$control.attr("anchor");
            var loadOnFocus = !!this.$control.attr("load-on-focus");
            var bindings = null;

            if (columns) {
                if (columns.indexOf('|') > -1) {
                    columns = columns.split("|");
                } else if (columns) {
                    columns = columns.split(",");
                }
            }

            if (binding) {
                bindings = binding.split(";");

                for (var i = 0; i < bindings.length; i++) {
                    var params = bindings[i].split(":");
                    bindings[i] = {
                        target: params[0],
                        source: params[1]
                    }
                }
            }

            if (strictCallback && Util.isFunction(this.parent[strictCallback])) {
                var method = this.parent[strictCallback];

                strictCallback = function() {
                    method.apply(self.parent, arguments);
                }
            } else {
                strictCallback = null;
            }

            this.autocomplete = this.textControl.use(UI.Plugin.XhrAutocomplete, {
                source: source,
                column: column,
                columns: columns,
                strict: strict,
                strictCallback: strictCallback,
                sourceOptions: sourceOptions,
                anchor: anchor
            });

            this.autocomplete.on("select", function(args) {
                var item = args.item;
                var textValue = item ? "" + item[column] : "";

                if (bindings) {
                    for (var i = 0; i < bindings.length; i++) {
                        try {
                            var source = bindings[i].source;
                            var target = self.parseTarget(bindings[i].target);

                            var value = item ? item[source] : null;

                            _.setWith(self.parent, target, value, self.pathCustomizer);
                        } catch (e) {
                            console.log("XhrAutocomplete set bound value failed", target, value);
                            console.dir(e);
                        }
                    }
                }

                self.setValue(textValue);

                if (self.parent && Util.isFunction(self.parent[handler])) {
                    self.parent[handler](args);
                }
            }).on("empty", function(args) {
                if (bindings) {
                    for (var i = 0; i < bindings.length; i++) {
                        try {
                            var target = self.parseTarget(bindings[i].target);

                            _.setWith(self.parent, target, undefined, self.pathCustomizer);
                        } catch (e) {
                            console.log("XhrAutocomplete set bound value failed", target, null);
                            console.dir(e);
                        }
                    }
                }

                self.setValue(undefined);
                self.textControl.plugin(UI.Plugin.XhrAutocomplete).read();

                if (self.parent && Util.isFunction(self.parent[emptyHandler])) {
                    self.parent[emptyHandler](args);
                }
            });

            if (loadOnFocus) {
				(this.$element.is('input') ? this.$element : this.$element.find('input[type=text]') ).on("focus", function() {
                    self.autocomplete.load().then(function() {
                        self.autocomplete.show();
                    });
                }).on("click", function(e) {
                    e.stopPropagation();
                });
            }
        },

        updateElement: function() {
            this.ParentCall();

            this.textControl.plugin(UI.Plugin.XhrAutocomplete).read();
        }
		//
		// setValue: function(value, update) {
		// 	if (!value) {
		// 		this.ParentCall()
		// 	}
		// }
    }
);
